module.exports = __webpack_public_path__ + "static/media/rosie-fraser-1L71sPT5XKc-unsplash.ef01524c.jpg";